import axiosInstance from "@/api/axiosInstance";
import { CallScoringSettings, UpdateCallScoringSettingsRequest } from "../types";

export const fetchCallScoringSettings = async (): Promise<CallScoringSettings> => {
  const response = await axiosInstance.get<CallScoringSettings>("/api/private/call-scoring-settings");
  return response.data;
};

export const updateCallScoringSettings = async (
  data: UpdateCallScoringSettingsRequest
): Promise<CallScoringSettings> => {
  const response = await axiosInstance.put<CallScoringSettings>("/api/private/call-scoring-settings", data);
  return response.data;
};